import { call, put, takeLatest } from "redux-saga/effects";
import {
  onEnquiryPost,
  onEnquiryPostSuccess,
  onEnquiryPostError,
  onGetEnquiries,
  onGetEnquiriesSuccess,
  onGetEnquiriesError,
  onEnquiryUpdate,
  onEnquiryUpdateSuccess,
  onEnquiryUpdateError,
  onEnquiryView,
  onEnquiryViewSuccess,
  onEnquiryViewError,
} from "../Store/Slices/enquirySlice";
import {
  callEnquiryPostApi,
  callGetEnquiriesApi,
  callUpdateEnquiryApi,
  callEnquiryViewApi,
} from "../Context/businessApi";

function* enquiryPostSaga({ payload }) {
  try {
    const response = yield call(callEnquiryPostApi, payload);
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200 || code === 201 || code === "201") {
      yield put(
        onEnquiryPostSuccess({
          message: response.message || "Enquiry submitted",
          status_code: code,
        })
      );
    } else {
      yield put(
        onEnquiryPostError({
          message: response.message || "Enquiry failed",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onEnquiryPostError({ message, status_code: 400 }));
  }
}

function* getEnquiriesSaga({ payload }) {
  try {
    const response = yield call(callGetEnquiriesApi, payload ?? {});
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200) {
      const data = response.data?.enquiries ?? response.data ?? null;
      yield put(
        onGetEnquiriesSuccess({
          data,
          message: response.message || "Enquiries retrieved",
          status_code: code,
        })
      );
    } else {
      yield put(
        onGetEnquiriesError({
          data: response.data ?? null,
          message: response.message || "Failed to fetch enquiries",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onGetEnquiriesError({ data: null, message, status_code: 400 }));
  }
}

function* enquiryUpdateSaga({ payload }) {
  try {
    const response = yield call(callUpdateEnquiryApi, payload);
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200) {
      yield put(
        onEnquiryUpdateSuccess({
          message: response.message || "Enquiry updated",
          status_code: code,
        })
      );
      yield put(onGetEnquiries());
    } else {
      yield put(
        onEnquiryUpdateError({
          message: response.message || "Update failed",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onEnquiryUpdateError({ message, status_code: 400 }));
  }
}

function* enquiryViewSaga({ payload }) {
  try {
    const response = yield call(callEnquiryViewApi, payload );
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200) {
      yield put(onEnquiryViewSuccess({ status_code: code }));
      yield put(onGetEnquiries());
    } else {
      yield put(
        onEnquiryViewError({
          status_code: code,
        })
      );
    }
  } catch (error) {
    yield put(onEnquiryViewError({ status_code: 400 }));
  }
}

export default function* enquirySaga() {
  yield takeLatest(onEnquiryPost.type, enquiryPostSaga);
  yield takeLatest(onGetEnquiries.type, getEnquiriesSaga);
  yield takeLatest(onEnquiryUpdate.type, enquiryUpdateSaga);
  yield takeLatest(onEnquiryView.type, enquiryViewSaga);
}
